export const fr = {
  // Common
  conversation: 'Conversation',
  connected: 'Connecté',
  disconnected: 'Déconnecté',
  loading: 'Chargement...',
  error: 'Erreur',
  
  // Welcome messages
  welcomeMessage: 'Bonjour, comment puis-je vous aider aujourd\'hui?',
  joinedChat: 'a rejoint le chat',
  
  // Chat actions
  createNewChat: 'Créer une nouvelle conversation',
  newConversation: 'Nouvelle conversation',
  moreResults: 'Je veux plus de résultats',
  
  // Input placeholders
  inputPlaceholder: 'Tapez un message...',
  inputPlaceholderGenerating: 'Génération des résultats...',
  
  // Loading messages
  collectingInfo: 'Collecte des informations nécessaires ...',
  searchingBestResults: 'Recherche des meilleurs résultats ...',
  analyzingDatabase: 'Analyse de la base de données pour la recherche ...',
  checkingSpecialOffers: 'Vérification des offres spéciales disponibles ...',
  searchingSimilarProducts: 'Recherche de produits similaires ...',
  preparingRecommendations: 'Préparation des recommandations personnalisées ...',
  checkingStock: 'Vérification du stock et de la disponibilité des produits ...',
  finalizingResponse: 'Finalisation de la réponse avec les options les plus pertinentes ...',
  
  // Thinking steps
  analyzingRequest: 'Analyse de votre demande ...',
  generatingSearchTerms: 'Génération des termes de recherche ...',
  processingSearchTerms: 'Traitement des termes de recherche ...',
  searchingDatabase: 'Recherche dans la base de données pour des produits adaptés ...',
  processingResults: 'Traitement des résultats trouvés ...',
  generatingEstimates: 'Génération des estimations de temps et de coût ...',
  generatingFinalResponse: 'Génération de la réponse finale ...',
  processingRequest: 'Findly réfléchit ...',
  
  // Status messages
  waitingPreviousResults: 'Attente des résultats de la conversation précédente ...',
  checkingContinuation: 'Vérification si la conversation peut continuer...',
  
  // Empty states
  noMessagesYet: 'Aucun message pour le moment',
  
  // Error messages
  failedCreateChat: 'Impossible de créer un nouveau chat. Veuillez réessayer.',
  errorCreatingChat: 'Erreur lors de la création du chat',
  errorSendingMessage: 'Erreur lors de l\'envoi du message',
  errorLoadingChats: 'Erreur lors du chargement des chats',
  
  // Cart messages
  productAddedToCart: 'Le produit {{productCode}} a été ajouté au panier!',
  
  // Chat titles
  defaultChatTitle: 'Chat {{timestamp}}',
  
  // Connection status
  connectionStatusConnected: 'Connecté 🟢',
  connectionStatusDisconnected: 'Déconnecté 🔴',

  // Chat encouragement messages (cycled every 5 seconds)
  chatEncouragement1: 'Je peux vous aider à trouver les produits que vous cherchez!',
  chatEncouragement2: 'Besoin d\'aide pour trouver quelque chose de spécifique?',
  chatEncouragement3: 'Laissez-moi vous assister dans vos achats!'
};
